import { Button } from '@sunwebgroup/uds-ui/button'
import { Dialog } from '@sunwebgroup/uds-ui/dialog'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { isEmpty } from 'ramda'
import { useIntl } from '@/intl'
import { AgeProfiles } from '@/scopes/prices/components/RoomSelector/AgeProfiles'
import { RoomGroup } from '@/scopes/prices/components/RoomSelector/RoomGroup'
import {
  getRoomsResponseSelector,
  getRoomsSelector,
  selectedPriceIdSelector,
} from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import styles from './RoomSelector.module.css'

export function RoomSelector() {
  const intl = useIntl()
  const selectedPriceId = usePricesSelector(selectedPriceIdSelector)
  const { roomGroups } = usePricesSelector(getRoomsResponseSelector)
  const { error: isError, loading: isFetching } = usePricesSelector(getRoomsSelector)

  if (isError) {
    return (
      <Dialog
        className={styles.contentUnavailable}
        text={intl.formatMessage({ id: 'prices_room_selector_error_title' })}
        supportingText={intl.formatMessage({ id: 'prices_room_selector_error_message' })}
        type="alert"
        actionsSlot={(
          <Button onClick={() => window.location.reload()}>
            {intl.formatMessage({ id: 'prices_error_reload_button' })}
          </Button>
        )}
      />
    )
  }

  if (isEmpty(roomGroups) || !selectedPriceId || isFetching)
    return null

  return (
    <div id="RoomSelector" className={styles.roomSelector}>
      <Typography className={styles.heading} variant="display-g-regular">{intl.formatMessage({ id: 'prices_room_selector-title' })}</Typography>
      <AgeProfiles />
      {roomGroups.map(roomGroup => (
        <RoomGroup key={roomGroup.roomNumber} {...roomGroup} />
      ))}
    </div>
  )
}
